export const imagekitConfig = {
  publicKey:
    process.env.VUE_APP_IMAGEKIT_PUBLIC_KEY ||
    'public_QRRKPnSGOpVXx3yDiyjkoMlvpvg=',
  privateKey:
    process.env.VUE_APP_IMAGEKIT_PRIVATE_KEY ||
    'private_2CoYa+lHEJk9H+CzHM0SCzC9tiw=',
  urlEndpoint:
    process.env.VUE_APP_IMAGEKIT_URL_ENDPOINT ||
    'https://ik.imagekit.io/urbn',
};
